import { render, staticRenderFns } from "./CartaoDePedidoDeCompra.vue?vue&type=template&id=5f31373e&scoped=true"
import script from "./CartaoDePedidoDeCompra.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDePedidoDeCompra.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDePedidoDeCompra.vue?vue&type=style&index=0&id=5f31373e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31373e",
  null
  
)

export default component.exports